export default __webpack_public_path__ + "static/DevandBeyond_Logo-bcf774faaeace4bb809319b7721c0867.svg";